var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-card',[_c('div',{attrs:{"id":"dashboard-card-leaderboard-loader"}},[_c('div',{key:_vm.key},[(_vm.leaderboard)?_c('dashboard-leaderboard-list',{attrs:{"leaderboard-resource":_vm.leaderboard}}):_vm._e()],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }